import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { SessionStorageService } from './session-storage';

@Injectable({
  providedIn: 'root'
})
export class BrowserCheckService {

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private readonly session: SessionStorageService) { }

  isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  isServer(): boolean {
    return !this.isBrowser();
  }

  // Safe localStorage access
  getLocalStorage(key: string): string | null {
    if (this.isBrowser() && typeof localStorage !== 'undefined') {
      return localStorage.getItem(key);
    }
    return null;
  }

  setLocalStorage(key: string, value: string): void {
    if (this.isBrowser() && typeof localStorage !== 'undefined') {
      localStorage.setItem(key, value);
    }
  }

  removeLocalStorage(key: string): void {
    if (this.isBrowser() && typeof localStorage !== 'undefined') {
      localStorage.removeItem(key);
    }
  }

  // Safe sessionStorage access
  getSessionStorage(key: string): string | null {
    if (this.isBrowser() && typeof sessionStorage !== 'undefined') {
      return this.session.getItem(key);
    }
    return null;
  }

  setSessionStorage(key: string, value: string): void {
    if (this.isBrowser() && typeof sessionStorage !== 'undefined') {
      this.session.setItem(key, value);
    }
  }

  removeSessionStorage(key: string): void {
    if (this.isBrowser() && typeof sessionStorage !== 'undefined') {
      this.session.removeItem(key);
    }
  }

  // Safe window access
  getWindow(): Window | null {
    if (this.isBrowser() && typeof window !== 'undefined') {
      return window;
    }
    return null;
  }
}
